import "./styles.scss";
import researchgatelogo from "./../../assets/research_gate.png";
import arxivlogo from "./../../assets/arxivlogo.svg";
import googlescholar from "./../../assets/googlescholar.png";
import logicGroup from "./../../assets/logic_group.png";


const Footer = () => {

    return (
        <div className={"Footer"} id={"links"}>
          <div className="links">
            <a className="link-image" target={"_blank"} href={"https://www.researchgate.net/profile/Pedro_Pinto17"}>
              <img src={researchgatelogo} width="40"
                   height="40" title="ResearchGate"
                   alt="ResearchGate" />
              <span>ResearchGate</span>
            </a>
            <a className="link-image" target={"_blank"} href={"https://arxiv.org/a/pinto_p_1.html"}>
              <img src={arxivlogo} width="40"
                   height="40" title="arXiv"
                   alt="arXiv"
              />
              <span>arXiv</span>
            </a>
            <a className="link-image" target={"_blank"}  href="https://scholar.google.com/citations?user=7KRPsK8AAAAJ&hl=en">
              <img src={googlescholar} width="40"
                   height="40" title="GoogleScholar"
                   alt="GoogleScholar"
              />
              <span>GoogleScholar</span>
            </a>
            <a className="link-image" target={"_blank"} href="https://www.mathematik.tu-darmstadt.de/logik/arbeitsgruppe_logik/index.en.jsp">
              <img src={logicGroup} width="40"
                   height="40" title="LogicGroup"
                   alt="LogicGroup" style={{borderRadius: "10px"}}/>
              <span>Logic group</span>
            </a>
          </div>
            <div className={"updated-date"}>This page was updated on July 2024</div>
        </div>
    );
}

export default Footer;